import React, { Component } from 'react';
import { withStyles } from 'material-ui';
import SeatSelectionDesktopContainerStyles from './SeatSelectionDesktopContainerStyles';
import SeatSelectionDesktopContainerProps from './SeatSelectionDesktopContainerProps';
// import Constants from '../../../../model/AppConfiguration';
import SeatSelectionHeader from '../common/seatSelection/SeatSelectionHeader';
import SeatSelection from '../common/seatSelection/SeatSelection';

/**
 * ## Redux imports
 */
import * as passengerActions from '../../../redux/actions/PassengerActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../../redux/selectors/Index';
import RouteTabs from '../../routeTabs/RouteTabs';
import SeatsLegend from '../../../components/seats/seatsLegend/SeatsLegend';
import SeatsInfo from '../../../components/seats/seatsInfo/SeatsInfo';

/**
 * ## Redux boilerplate
 */
const actions = [ passengerActions ];

function mapStateToProps (state) {
  return {
    isFetching: selectors.global.isFetching(state.global),
    flights: selectors.flights.getFlights(state.flights),
    passengers: selectors.passengers.getPassengers(state.passengers),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

class SeatSelectionDesktopContainer extends Component {
  static propTypes = SeatSelectionDesktopContainerProps;

  constructor (props) {
    super(props);

    this.state = { passenger: this.getSelectedPassenger(props) };
  }

  componentWillReceiveProps (props) {
    this.setState({ passenger: this.getSelectedPassenger(props) });
  }

  getSelectedPassenger (props) {
    const { selectedRoute, flights, selectedPassenger } = props;
    let passengers = [];
    if (selectedRoute && selectedRoute.id) {
      let flight = selectors.flights.getFlightByRouteId(flights, selectedRoute.id);
      passengers = flight.passengers;
    }
    if (selectedPassenger) {
      let flightPassenger = selectors.passengers.getPassengerById(passengers, selectedPassenger);
      let passenger = selectors.passengers.getPassengerById(props.passengers, selectedPassenger);
      return Object.assign({}, passenger, flightPassenger);
    }
    return {};
  }

  render () {
    const {
      classes,
      handleClose,
      routes,
      centered,
      showDate,
      selectedTrip,
      selectedRoute,
      toggleRoutes,
      selectedPassenger,
    } = this.props;

    const { passenger } = this.state;

    return (
      <div className={classes.backgroundWrapper}>
        <form className={classes.container} noValidate autoComplete='off'>
          <SeatSelectionHeader
            showSeat
            handleClose={handleClose}
            title={`${passenger.firstName} ${passenger.lastName}`}
            seat={`${passenger.seatPreview}`}
          />

          <RouteTabs
            centered={centered}
            showDate={showDate}
            routes={routes}
            selectedTrip={selectedTrip}
            selectedRoute={selectedRoute}
            toggleRoutes={toggleRoutes}
            TabContent={
              <div>
                <SeatsLegend />
                <SeatsInfo />
                <SeatSelection
                  selectedPassenger={selectedPassenger}
                  routeId={selectedRoute ? selectedRoute.id : ''}
                />
              </div>
            }
          />
        </form>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(SeatSelectionDesktopContainerStyles)(SeatSelectionDesktopContainer)
);



// WEBPACK FOOTER //
// ./src/containers/seats/desktop/SeatSelectionDesktopContainer.js